'use client';

import { Box, Container, Typography } from '@mui/material';
import { getOfficialAnnouncementInfo } from '@/types/officialAnnouncement';

type Props = {
  officialAnnouncementInfo: ReturnType<typeof getOfficialAnnouncementInfo>;
};

export const OfficialAnnouncementsDetailPage: React.FC<Props> = ({
  officialAnnouncementInfo,
}) => {
  return (
    <Container
      sx={{
        padding: '24px',
      }}
    >
      <Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 4,
          }}
        >
          <Typography
            variant="JP/Heading/xl/Bold/Tight"
            component="h1"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 2,
              flexWrap: 'wrap',
            }}
          >
            運営からのお知らせ
          </Typography>
        </Box>

        <Box>
          <Typography variant="JP/Heading/s/Bold/Tight">
            {officialAnnouncementInfo.value.title}
          </Typography>
          <Box
            sx={{ whiteSpace: 'pre-wrap' }}
            dangerouslySetInnerHTML={{
              __html: officialAnnouncementInfo.value.body || '',
            }}
          />
        </Box>
      </Box>
    </Container>
  );
};
